import { SERVICE_URL } from "@/shared/config";
import { QueryClient } from "@tanstack/react-query";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";

import React, { Suspense } from "react";
import { Helmet } from "react-helmet-async";
interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent
});

const TanstackRouterDevtools =
  process.env.NODE_ENV === "production"
    ? () => null
    : React.lazy(() =>
        import("@tanstack/router-devtools").then(res => ({
          default: res.TanStackRouterDevtools
        }))
      );

function RootComponent() {
  return (
    <>
      <Helmet>
        <title>MARU SF</title>
        <meta name="description" content="Global hub for startup" />
        <meta property="og:title" content="MARU SF" />
        <meta property="og:description" content="Global hub for startup" />
        <meta
          property="og:image"
          content="https://asan-nanum.org/wp-content/uploads/2023/02/%EC%B2%A8%EB%B6%80%EC%95%84%EC%82%B0%EB%82%98%EB%88%94%EC%9E%AC%EB%8B%A8-%EC%8B%A0%EA%B7%9C-CI-%EC%82%AC%EC%A7%84-1%EB%B6%80-scaled.jpg"
        />
        <meta property="og:image:width" content="800" />
        <meta property="og:image:height" content="600" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${SERVICE_URL}`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:image"
          content="https://asan-nanum.org/wp-content/uploads/2023/02/%EC%B2%A8%EB%B6%80%EC%95%84%EC%82%B0%EB%82%98%EB%88%94%EC%9E%AC%EB%8B%A8-%EC%8B%A0%EA%B7%9C-CI-%EC%82%AC%EC%A7%84-1%EB%B6%80-scaled.jpg"
        />
        <meta name="twitter:title" content="MARU SF" />
        <meta name="twitter:description" content="Global hub for startup" />
        <meta name="twitter:url" content={`${SERVICE_URL}`} />
      </Helmet>
      <Outlet />
      <Suspense>
        <TanstackRouterDevtools position="bottom-left" />
      </Suspense>
    </>
  );
}
